var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwittergrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1009",
    d: "M0.24381 0L38.8527 55.1559L0 100H8.74418L42.7596 60.7383L70.2432 100H100L59.2188 41.7417L95.3826 0H86.6384L55.3119 36.1592L30.0006 0H0.24381ZM13.1028 6.88168H26.7731L87.139 93.1173H73.4687L13.1028 6.88168Z",
    fill: "#7A7A7A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwittergrey);
export default __webpack_public_path__ + "static/media/twittergrey.9a216a7a488fc22cdc26ee9d7b76817e.svg";
export { ForwardRef as ReactComponent };